/* @flow */

import * as React from 'react';

import {VisitorSidebar} from 'shells/visitor-sidebar';

import {useGetMcfxCompany} from '../graphql/hooks/use-get-mcfx-company';
import {useGetMcfxViqContacts} from '../graphql/hooks/use-get-mcfx-viq-contacts';

import {VisitorTimeline} from './visitor-timeline';

import {getSessionDetails} from './helpers';

type Props = {|
    visitorId: string,
    onClose: () => void,
|};

export function CompanyVisitorsSidebar(props: Props) {
    const {mcfxCompany} = useGetMcfxCompany(props.visitorId);
    const {mcfxViqContacts} = useGetMcfxViqContacts(mcfxCompany && mcfxCompany.id);

    return (
        <VisitorSidebar
            onClose={props.onClose}
            company={
                mcfxCompany && {
                    details: {
                        name: mcfxCompany.name,
                        timestamp:
                            mcfxCompany.convertedTime ||
                            mcfxCompany.lastSeenTime ||
                            mcfxCompany.createdTime,
                        htmlUrlPath: mcfxCompany.relatedAccount
                            ? mcfxCompany.relatedAccount.htmlUrlPath
                            : undefined,
                        url: mcfxCompany.url,
                        location: mcfxCompany.primaryAddress && mcfxCompany.primaryAddress.region,
                        industry: mcfxCompany.industry && mcfxCompany.industry.name,
                        revenue: mcfxCompany.annualRevenue && mcfxCompany.annualRevenue.amount,
                        numEmployees: mcfxCompany.numEmployees,
                    },
                    session: getSessionDetails(
                        mcfxCompany.numVisits,
                        mcfxCompany.totalVisitDuration
                    ),
                    sessionsTimeline: (
                        <VisitorTimeline
                            companyId={mcfxCompany.id}
                            companyName={mcfxCompany.name}
                            sessions={mcfxCompany.mcfxSessions}
                        />
                    ),
                }
            }
            people={
                mcfxViqContacts &&
                mcfxViqContacts.map((mcfxViqContact) => ({
                    id: mcfxViqContact.id,
                    name: mcfxViqContact.fullName,
                    location: mcfxViqContact.location,
                    jobTitle: mcfxViqContact.jobTitle,
                    position: mcfxViqContact.position,
                    hasEmail: mcfxViqContact.hasEmail,
                    hasPhone: mcfxViqContact.hasPhone,
                    contact: mcfxViqContact.contact
                        ? {
                              htmlUrlPath: mcfxViqContact.contact.htmlUrlPath,
                              email:
                                  mcfxViqContact.contact &&
                                  mcfxViqContact.contact.emailAddresses.primary &&
                                  mcfxViqContact.contact.emailAddresses.primary.value.address,
                              phone:
                                  mcfxViqContact.contact &&
                                  mcfxViqContact.contact.phones.primary &&
                                  mcfxViqContact.contact.phones.primary.value.numberFormatted,
                          }
                        : undefined,
                }))
            }
        />
    );
}
